import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsAlert from '@/components/vision/VsAlert.vue'

interface Props {
  initialText: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkEditComponent',
  props: {
    initialText: null
  },
  emits: ["apply", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'apply', bulkOptions: string[]): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialText: string
}




const bulkEditText = ref(props.initialText)

watch(
  () => props.initialText,
  (newText) => {
    bulkEditText.value = newText
  }
)

function updateText(options: string) {
  bulkEditText.value = options
    .split(/\n+/)
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .join('\n')
}

function apply() {
  const bulkOptions = bulkEditText.value
    .split(/\n+/)
    .map((option) => option.trim())
    .filter((option) => option !== '')
  emit('apply', bulkOptions)
}

return { __sfc: true,props, emit, bulkEditText, updateText, apply, VsTextInput, VsButton, VsWrapper, VsAlert }
}

})